module.exports = __webpack_public_path__ + "img/A58A0622_min.6aca6f9a.jpg";